<div class="container-fluid">
  <div class="container">
    <div class="org-cards-wrapper p-5">
      @for (organization of getUserService().getAllOrganizations(); track organization; let i = $index) {
        <mat-card class="org-card-compact" [ngClass]="{'org-card-current': getUserService().currentOrganization.id === organization.id}" (click)="changeCurrentOrganization(organization.id)">
          <div class="org-card-content">
            <img [src]="organization?.logo_link || 'assets/img/placeholder-img-organization.jpg'"
              (error)="$any($event.target).src='assets/img/placeholder-img-organization.jpg'"
              class="org-logo-small" alt="">
            <p class="org-name">{{organization.name}}</p>
            @if (organization?.roles?.length) {
              <p class="org-role-label">{{'generic.roles.role' | translate}}</p>
              <p class="org-role">
                @for (orgRole of organization.roles; track orgRole; let last = $last) {
                  {{orgRole?.role?.role}}{{last ? '' : ', '}}
                }
              </p>
            }
          </div>
          <div class="org-card-footer">
            @if (getUserService().currentOrganization.id === organization.id) {
              <mat-icon class="org-footer-icon">check_circle</mat-icon>
              <span>{{'general.current' | translate}}</span>
            } @else {
              <mat-icon class="org-footer-icon">touch_app</mat-icon>
              <span>{{'general.select' | translate}}</span>
            }
          </div>
        </mat-card>
      }
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 d-flex justify-content-center">
    <button class="btn-custom btn-magic-add d-flex align-items-center px-5 py-2" [routerLink]="['../new']">
      <mat-icon class="mr-2">add</mat-icon>
      {{'pages.organizations.organization-management.component.organization-create' | translate}}
    </button>
  </div>
</div>

